import { createStore, type ReadOnlyStore } from "@observe-tech/mfe-shell-api";

export interface MfeErrorState {
  appName: string;
  message: string;
}

export interface MfeErrorApi {
  state: ReadOnlyStore<MfeErrorState | null>;
  set(appName: string, err: unknown): void;
  clear(): void;
}

export function createMfeErrorApi(): MfeErrorApi {
  const handle = createStore<MfeErrorState | null>(null);
  return {
    state: handle.store,
    set(appName, err) {
      const message =
        err instanceof Error
          ? err.message
          : typeof err === "string"
            ? err
            : "Unknown error";
      handle.set({ appName, message });
    },
    clear() {
      handle.set(null);
    },
  };
}
